import { useItineraryContext } from "modules/PortPredictor/hooks/itineraryContext"
import { useEffect, useState } from "react"
import { Form, InputGroup } from "react-bootstrap"

interface PortPredictorDaysInPortInputProps {
  portTurnAroundTime: string | undefined
  setPortTurnAroundTime: (time: string | undefined) => void
}

export function PortPredictorDaysInPortInput({
  portTurnAroundTime,
  setPortTurnAroundTime,
}: PortPredictorDaysInPortInputProps) {
  const { getTabStateKeyValue } = useItineraryContext()
  const [localPortTurnAroundTime, setLocalPortTurnAroundTime] = useState<
    string | undefined
  >(portTurnAroundTime === undefined ? undefined : String(portTurnAroundTime))

  useEffect(() => {
    const time =
      portTurnAroundTime === undefined ? "" : String(portTurnAroundTime)
    setLocalPortTurnAroundTime(time)
  }, [portTurnAroundTime])

  return (
    <>
      <Form.Label className="PortPredictor_FormLabel fw-bold">
        <>Est. Turn Around Time</>
      </Form.Label>
      <InputGroup className="PortPredictor_InputGroup">
        <Form.Control
          disabled={!getTabStateKeyValue("isEditMode")}
          className="ms-0"
          placeholder="Est. Days in Port"
          aria-label="Est. Days in Port"
          aria-describedby="est-days-in-port"
          value={localPortTurnAroundTime}
          type="number"
          onChange={(event) => {
            if (event.target.value) {
              if (!event.target.value) {
                return
              }
              setLocalPortTurnAroundTime(event.target.value)
              setPortTurnAroundTime(event.target.value)
              return
            }
            setLocalPortTurnAroundTime("")
          }}
        />
        <InputGroup.Text id="turnAroundTime">Days</InputGroup.Text>
      </InputGroup>
    </>
  )
}
